import { zodResolver } from "@hookform/resolvers/zod";
import { Button, Grid } from "@mui/material";
import { useUpdateSettingMutation } from "api/settings/settings.mutation";
import DatePickerField from "components/DatePickerField";
import EditorField from "components/EditorField";
import { Modal } from "components/Modal";
import { handleError } from "functions/apiHandleError";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { schema } from "schema/settings/updateSettingsModal";
import classes from "./style.module.scss";

export const EditSettingsModal = ({ open, onClose, defaultData }) => {
  const { handleSubmit, reset, setError, control } = useForm({
    mode: "onChange",
    resolver: zodResolver(schema),
    defaultValues: {
      fa_terms: "",
      en_terms: "",
      ar_terms: "",
      start_bachelor_register_date: "",
      end_bachelor_register_date: "",
      start_register_date: "",
      end_register_date: "",
      start_phd_register_date: "",
      end_phd_register_date: "",
    },
  });

  const updateSettingMutation = useUpdateSettingMutation();

  const handleCloseModal = () => {
    reset({
      fa_terms: "",
      en_terms: "",
      ar_terms: "",
      start_bachelor_register_date: "",
      end_bachelor_register_date: "",
      start_register_date: "",
      end_register_date: "",
      start_phd_register_date: "",
      end_phd_register_date: "",
    });
    onClose();
  };
  const handleSubmitForm = async (data) => {
    try {
      data.start_bachelor_register_date = data.start_bachelor_register_date.split("T")[0];
      data.end_bachelor_register_date = data.end_bachelor_register_date.split("T")[0];
      data.start_register_date = data.start_register_date.split("T")[0];
      data.end_register_date = data.end_register_date.split("T")[0];
      data.start_phd_register_date = data.start_phd_register_date.split("T")[0];
      data.end_phd_register_date = data.end_phd_register_date.split("T")[0];
      await updateSettingMutation.mutateAsync(data);
      toast.success("با موفقیت انجام شد");
      handleCloseModal();
    } catch (err) {
      handleError({ err, setError });
    }
  };

  useEffect(() => {
    if (defaultData) {
      reset({
        fa_terms: defaultData?.fa_terms ?? "",
        en_terms: defaultData?.en_terms ?? "",
        ar_terms: defaultData?.ar_terms ?? "",
        start_bachelor_register_date: defaultData?.start_bachelor_register_date,
        end_bachelor_register_date: defaultData?.end_bachelor_register_date,
        start_register_date: defaultData?.start_register_date,
        end_register_date: defaultData?.end_register_date,
        start_phd_register_date: defaultData?.start_phd_register_date,
        end_phd_register_date: defaultData?.end_phd_register_date,
      });
    }
  }, [defaultData]);

  return (
    <Modal
      open={open}
      title="ویرایش تنظیمات"
      onClose={handleCloseModal}
      maxWidth="sm"
      footerEnd={
        <>
          <Button
            variant="contained"
            size="xsmall"
            loading={updateSettingMutation.isPending}
            color="success"
            onClick={handleSubmit(handleSubmitForm)}
          >
            ثبت
          </Button>
          <Button variant="contained" color="error" size="xsmall" onClick={handleCloseModal}>
            بستن
          </Button>
        </>
      }
    >
      <Grid
        container
        spacing={3}
        component="form"
        onSubmit={handleSubmit(handleSubmitForm)}
        className={classes.wrapper}
      >
        <Grid item xs={12}>
          <EditorField label="قوانین فارسی ثبت نام" control={control} name="fa_terms" />
        </Grid>
        <Grid item xs={12}>
          <EditorField label="قوانین انگلیسی ثبت نام" control={control} name="en_terms" />
        </Grid>
        <Grid item xs={12}>
          <EditorField label="قوانین عربی ثبت نام" control={control} name="ar_terms" />
        </Grid>
        <Grid item xs={12}>
          <DatePickerField
            label="تاریخ شروع ثبت نام کارشناسی"
            required
            control={control}
            name="start_bachelor_register_date"
          />
        </Grid>
        <Grid item xs={12}>
          <DatePickerField
            label="تاریخ اتمام ثبت نام کارشناسی"
            required
            control={control}
            name="end_bachelor_register_date"
          />
        </Grid>
        <Grid item xs={12}>
          <DatePickerField
            label="تاریخ شروع ثبت نام کارشناسی ارشد"
            required
            control={control}
            name="start_register_date"
          />
        </Grid>
        <Grid item xs={12}>
          <DatePickerField
            label="تاریخ اتمام ثبت نام کارشناسی ارشد"
            required
            control={control}
            name="end_register_date"
          />
        </Grid>
        <Grid item xs={12}>
          <DatePickerField
            label="تاریخ شروع ثبت نام دکترا"
            required
            control={control}
            name="start_phd_register_date"
          />
        </Grid>
        <Grid item xs={12}>
          <DatePickerField
            label="تاریخ اتمام ثبت نام دکترا"
            required
            control={control}
            name="end_phd_register_date"
          />
        </Grid>
      </Grid>
    </Modal>
  );
};
